/**
 * Shared button styling constants for the audience import wizard.
 * Main CTAs use the `cta` variant (Action Color brand seed) rather than the
 * `primary` accent token used for highlights and links.
 *
 * @see apps/frontend/src/pages/SettingsPage/components/BrandTab.tsx — cta seed
 */
export const AUDIENCE_WIZARD_BUTTON_VARIANT = 'cta' as const
export const AUDIENCE_WIZARD_BUTTON_CLASS = 'text-[16px] font-medium tracking-[-0.02em]'
